import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a3122ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4a3122ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3122ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a3122ea')) {
      api.createRecord('4a3122ea', component.options)
    } else {
      api.reload('4a3122ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a3122ea&scoped=true", function () {
      api.rerender('4a3122ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/board/chart/bar/base/IkBarBaseChart/index.vue"
export default component.exports